import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"


class Firmas extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Cargo",
                    id: "cargo",
                    accessor: d => d.cargo,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        permission: 'firmas_add',
                        component: Create,
                    },
                    {
                        edit:true,
                        permission: 'firmas_edit',
                        component: Edit,
                    },
                    {
                        detail: true,
                        permission: 'firmas_detail',
                        component: Detail,
                    },
                    {
                        edit:true,
                        permission: 'firmas_delete',
                        component: Delete,
                    }
                ]}

                apiUrl={api.proyectos.config.firmas.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.config.firmas.export}
                title={"Firmas"}
                outerSort={[{"id":"nombre","desc":false}]}
            />
        );
    }
}

export default Firmas;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Firmas/Firmas.js